export default "__VITE_ASSET__05f75f55__"